module.exports = __webpack_public_path__ + "static/30-ed87a47ce07b647f12f0e2dff3a9aab3.png";